import { render, staticRenderFns } from "./ClientLicense.vue?vue&type=template&id=51c2a100&scoped=true&"
import script from "./ClientLicense.vue?vue&type=script&lang=js&"
export * from "./ClientLicense.vue?vue&type=script&lang=js&"
import style0 from "./ClientLicense.vue?vue&type=style&index=0&id=51c2a100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2a100",
  null
  
)

export default component.exports